import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const ButtonContainer = styled(Row)`
  justify-content: center;
  align-items: center;
  opacity: 0.65;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  svg {
    outline: none;
  }
`;

export const BorderedButtonContainer = styled(ButtonContainer)`
  border: 1px solid ${({ theme }) => theme.colors.separatorOnGray};
  border-radius: 4px;
`;
